import React from 'react';
import {observer} from 'mobx-react-lite';
import {ModalWindow} from 'components/ModalWindow';
import {FFButton} from 'ui/FFButton';
import {useL10n} from 'i18n/hooks';
import {useMyLogout} from 'hooks/useAuth';
import {useStores} from 'stores/rootStore';
import './style.scss';

/**
 * The boot gave up (UserStore.bootFailure). Unreachable backend: reload — dismissible when an
 * account snapshot keeps the page usable. Rejected token: nothing works, logout is the only way out.
 */
export const BootFailedModal = observer(() => {
    const {user} = useStores();
    const {t} = useL10n();
    const logout = useMyLogout();
    const expired = user.bootFailure === 'session_expired';
    const dismissible = user.isReady() && !expired;
    return (
        <ModalWindow open={user.bootFailed} width={311} className="boot-failed-modal" rootClassName="boot-failed-modal-root"
                     closable={dismissible} keyboard={dismissible} maskClosable={false}
                     onCancel={() => user.setBootFailure(null)}>
            <div className="boot-failed-modal__content" role="alert" data-testid="boot-failed">
                <div className="boot-failed-modal__head">
                    <div className="boot-failed-modal__title">{t(expired ? 'session-expired-title' : 'boot-failed-title')}</div>
                    <p className="boot-failed-modal__body">{t(expired ? 'session-expired-body' : 'boot-failed-body')}</p>
                </div>
                {expired
                    ? <FFButton size="m" block onClick={logout}>{t('button-logout')}</FFButton>
                    : <FFButton size="m" block onClick={() => window.location.reload()}>{t('boot-failed-reload')}</FFButton>}
            </div>
        </ModalWindow>
    );
});
